export default {
  meta: {
    title: '合同',
    disabled: true
  }
};
